import { render, staticRenderFns } from "./CardMapRelatorio.vue?vue&type=template&id=b22cbf4e"
import script from "./CardMapRelatorio.vue?vue&type=script&lang=js"
export * from "./CardMapRelatorio.vue?vue&type=script&lang=js"
import style0 from "./CardMapRelatorio.vue?vue&type=style&index=0&id=b22cbf4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports